import { HIDE_TOAST, SHOW_TOAST } from "../actions/toast-actions";

const initialState = {
  open: false,
  message: "",
  variant: "info",
};

const ToastReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        open: true,
        message: action.payload.message,
        variant: action.payload.variant,
      };

    case HIDE_TOAST:
      return {
        ...state,
        open: false,
      };

    default:
      return state;
  }
};

export default ToastReducer;
